var lx = lx || {};
lx.lang = lx.lang || {};

/*/* before was switchLang function*/
lx.lang = {
    set: function (pCode, pValue) {
		if (confirm(apex.lang.getMessage("JS42"))) {
			/*$.ajax({
				url: "wwv_flow.show",
				dataType: "text",
				traditional: true,
				cache: false,
				type: "POST",
				data: {
					p_flow_id: $v("pFlowId"),
					p_flow_step_id: $v("pFlowStepId"),
					p_instance: $v("pInstance"),
					p_request: "APPLICATION_PROCESS=logout_link"
				},
				success: function (d) {
					lx.pref.set(pCode, pValue);
					setTimeout(function () { redirect(d); }, 1000);
				}
			});*/
			apex.server.process("logout_link",{},
			{
				dataType: "text",
				success: function (d) {
					lx.pref.set(pCode, pValue);
					setTimeout(function () { redirect(d); }, 1000);
				}
			});
		}
	}
};

// TODO cleanup after we ditch the old app
var switchLang = lx.lang.set;

